class WishlistShare extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.trigger) {
      this.listeners.add(
        this.els.trigger.element,
        'click',
        this.onTriggerClick.bind(this),
      )
    }

    this.listeners.add(this, 'click', this.onCloseClick.bind(this))

    if (this.els.shareForm) {
      this.listeners.add(
        this.els.shareForm.element,
        'submit',
        this.onShare.bind(this),
      )
    }

    // Share link
    this.listeners.add(
      this.els.urlInput?.element,
      'focus',
      this.onUrlInputFocus.bind(this),
    )
    this.listeners.add(
      this.els.copyUrl?.element,
      'click',
      this.onCopyUrlClick.bind(this),
    )
    this.listeners.add(
      this.els.copyApi?.element,
      'click',
      this.onCopyApiClick.bind(this),
    )

    // Navigation buttons
    this.listeners.add(
      this.els.shareViaLink.element,
      'click',
      this.onShareViaLinkClick.bind(this),
    )
    this.listeners.add(
      this.els.shareViaEmail.element,
      'click',
      this.onShareViaEmailClick.bind(this),
    )

    // External trigger elements
    this.externalEls.trigger.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', this.onTriggerClick.bind(this))
    })
    this.externalEls.triggerEmail.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', this.onTriggerEmailClick.bind(this))
    })

    this.listeners.add(
      this.els.addPerson?.element,
      'click',
      this.addPersonClicked.bind(this),
    )
  }

  onTriggerClick (event) {
    event.preventDefault()

    this.open()
  }

  onTriggerEmailClick (event) {
    event.preventDefault()

    this.open()
  }

  onCloseClick (event) {
    const target = event.target.closest(this.els?.close?.selector)
    if (!target) return

    this.close()
  }

  onShareViaLinkClick (event) {
    this.els.shareOptions.element.style.display = 'none'
    this.els.shareForm.element.style.display = 'none'
    this.els.shareLink.element.style.display = 'block'
  }

  onShareViaEmailClick (event) {
    this.els.shareOptions.element.style.display = 'none'
    this.els.shareForm.element.style.display = 'block'
    this.els.shareLink.element.style.display = 'none'
  }

  onUrlInputFocus (e) {
    this.els?.urlInput?.element.select()
  }

  onCopyUrlClick (event) {
    event.preventDefault()

    const input = this.els?.urlInput?.element
    const button = this.els?.copyUrl?.element

    input.select()
    input.setSelectionRange(0, 99999)

    navigator.clipboard.writeText(input.value)

    button.innerText = button.dataset.copiedText

    window.setTimeout(() => {
      button.innerText = button.dataset.copyText
    }, 3000)
  }

  onCopyApiClick (event) {
    event.preventDefault()

    if (!navigator.canShare) {
      alert(`Your browser doesn't support the Web Share API.`)
    }

    navigator.share({ url: this.els.urlInput.element.value })
  }

  async onShare (event) {
    event.preventDefault()

    this.error = ''

    const form = event.target

    const button = form.querySelector('.wlt-ShareModal_Button')
    const formData = new FormData(form)

    const emails = formData.getAll('email[]')

    if (emails.length === 0 || emails.every(email => email === '')) {
      this.error = `You must provide an email before sharing`

      return
    }

    button.setAttribute('aria-busy', true)

    const response = await this.updateWishlist(formData, '/set-collaborators')

    button.setAttribute('aria-busy', false)

    const isSuccessful = response.success

    if (isSuccessful) {
      this.handleSuccessfulShare(button)
    } else {
      this.handleUnsuccessfulShare(button, response)
    }

    window.setTimeout(() => {
      button.innerText = button.dataset.shareText
    }, 3000)
  }

  handleSuccessfulShare (button) {
    button.innerText = button.dataset.sharedText

    this.els.emailRecords.element.style.display = 'none'
    this.els.successMessage.element.style.display = 'block'

    for (const [index, element] of this.els.emailRecord.elements.entries()) {
      if (index > 0) {
        element.remove()
      } else {
        element.querySelector('input').value = ''
        element.querySelector('select').value = 'view'
      }
    }

    window.setTimeout(() => {
      this.els.emailRecords.element.style.display = 'block'
      this.els.successMessage.element.style.display = 'none'
    }, 3000)
  }

  handleUnsuccessfulShare (button, response) {
    button.innerText = `Error Updating`

    const emailsString =
      response.unprocessed_emails.length > 1 ? 'emails' : 'email'

    this.error = `Unable to share with "${response.unprocessed_emails.join(
      ', ',
    )}" ${emailsString}`
  }

  open () {
    document.body.classList.add('util-SiteOverflowed')

    this.els?.modal?.element.setAttribute('aria-hidden', 'false')

    this.els.shareOptions.element.style.display = 'block'
    this.els.shareForm.element.style.display = 'none'
    this.els.shareLink.element.style.display = 'none'
  }

  close () {
    this.els?.modal?.element.setAttribute('aria-hidden', 'true')

    document.body.classList.remove('util-SiteOverflowed')
  }

  async updateWishlist (formData, endpoint = '/', update = false) {
    const response = await fetch(
      `${window.theme.appSettings.baseUrl}/api/lists/${this.listId}${endpoint}`,
      {
        method: update ? 'PUT' : 'POST',
        headers: {
          Authorization: `Bearer ${window.BAO.wishlist.token}`,
        },
        body: formData,
      },
    ).then(response => response.json())

    return response
  }

  async addPersonClicked (event) {
    event.preventDefault()

    // Create a duplicate of the first email record and append it
    const newRecord = this.els.emailRecord.elements[0].cloneNode(true)
    newRecord.querySelector('input').value = ''
    newRecord.querySelector('select').value = 'view'
    this.els.emailRecords.element.appendChild(newRecord)
  }

  get error () {
    return this._error
  }

  set error (message) {
    this._error = message
    this.els.emailInputError.element.innerText = message
    this.els.emailInputError.element.style.display = message ? 'block' : 'none'
  }

  get listId () {
    return this.dataset.listId
  }
}

customElements.define('wishlist-share', WishlistShare)
